const GooglePlayIcon = (props: any) => (
  <svg xmlSpace="preserve" id="katman_1" viewBox="0 30 440 450" {...props}>
    <style>
      {
        ".st1{fill:url(#SVGID_00000179606376581035656770000002890124957261272464_)}.st2{fill:url(#SVGID_00000015342096325603936440000009206276253905037972_)}.st3{fill:url(#SVGID_00000106858722651072857310000009866101373382940320_)}"
      }
    </style>
    <linearGradient
      id="SVGID_1_"
      x1={17.154}
      x2={9.238}
      y1={458.657}
      y2={454.574}
      gradientTransform="matrix(25.92 0 0 49.67 -141.418 -22419.717)"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        offset={0}
        style={{
          stopColor: "#00a0ff",
        }}
      />
      <stop
        offset={0.007}
        style={{
          stopColor: "#00a1ff",
        }}
      />
      <stop
        offset={0.26}
        style={{
          stopColor: "#00beff",
        }}
      />
      <stop
        offset={0.512}
        style={{
          stopColor: "#00d2ff",
        }}
      />
      <stop
        offset={0.76}
        style={{
          stopColor: "#00dfff",
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: "#00e3ff",
        }}
      />
    </linearGradient>
    <path
      d="M164.3 74.7c-3.6 3.7-5.7 9.5-5.7 17V359c0 7.5 2.1 13.3 5.7 17l.9.8 151.5-149.7v-3.5L165.2 73.9l-.9.8z"
      style={{
        fill: "url(#SVGID_1_)",
      }}
    />
    <linearGradient
      id="SVGID_00000008831108670190551250000008655584095678749585_"
      x1={27.499}
      x2={12.979}
      y1={466.353}
      y2={466.353}
      gradientTransform="matrix(20.376 0 0 16.951 -109.955 -7679.807)"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        offset={0}
        style={{
          stopColor: "#ffe000",
        }}
      />
      <stop
        offset={0.409}
        style={{
          stopColor: "#ffbd00",
        }}
      />
      <stop
        offset={0.775}
        style={{
          stopColor: "orange",
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: "#ff9c00",
        }}
      />
    </linearGradient>
    <path
      d="m367.1 277-50.4-49.9v-3.5l50.5-49.9 1.1.7 59.8 33.6c17.1 9.6 17.1 25.3 0 34.9l-59.8 33.6-1.2.5z"
      style={{
        fill: "url(#SVGID_00000008831108670190551250000008655584095678749585_)",
      }}
    />
    <linearGradient
      id="SVGID_00000015324761518190072170000005717156362165513632_"
      x1={10.768}
      x2={2.451}
      y1={462.403}
      y2={451.612}
      gradientTransform="matrix(33.458 0 0 25.4886 -148.026 -11513.274)"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        offset={0}
        style={{
          stopColor: "#ff3a44",
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: "#d8176e",
        }}
      />
    </linearGradient>
    <path
      d="m368.3 276.4-51.6-51L164.3 376c5.7 5.9 14.9 6.6 25.4.7l178.6-100.3"
      style={{
        fill: "url(#SVGID_00000015324761518190072170000005717156362165513632_)",
      }}
    />
    <linearGradient
      id="SVGID_00000033340800685178924380000004587992085989064877_"
      x1={4.361}
      x2={8.075}
      y1={468.002}
      y2={463.182}
      gradientTransform="matrix(33.459 0 0 25.4775 -148.028 -11533.731)"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        offset={0}
        style={{
          stopColor: "#32a071",
        }}
      />
      <stop
        offset={0.069}
        style={{
          stopColor: "#2da771",
        }}
      />
      <stop
        offset={0.476}
        style={{
          stopColor: "#15cf74",
        }}
      />
      <stop
        offset={0.801}
        style={{
          stopColor: "#06e775",
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: "#00f076",
        }}
      />
    </linearGradient>
    <path
      d="M368.3 174.3 189.7 74c-10.5-5.8-19.8-5.1-25.4.8l152.4 150.6 51.6-51.1z"
      style={{
        fill: "url(#SVGID_00000033340800685178924380000004587992085989064877_)",
      }}
    />
  </svg>
);
export default GooglePlayIcon;
